import React from 'react';
import { Link2 } from 'lucide-react';
import { moduleApi } from '../../../../lib/api';
import { pillSecondary } from '../../../ui/pills';

export interface AccesOrganisateur {
    id: string; name: string; email: string; token: string; expires_at: string; revoked_at: string | null;
    first_login_at: string | null; last_seen_at: string | null; code_sent_at: string | null; created_at: string;
    etat: 'ok' | 'expire' | 'revoque';
}
export interface LigneJournalOrga { created_at: string; actor_label: string; source: 'portail' | 'etablissement'; action: string; text: string }
export interface AccesInfo { acces: AccesOrganisateur[]; journal: LigneJournalOrga[]; contact: { name: string; email: string }; max: number }

/** Les accès organisateur d'un événement et leur journal — partagé entre la carte, la modale et le sélecteur d'envoi. */
export function useOrganisateurAcces(eventId: string) {
    const [info, setInfo] = React.useState<AccesInfo | null>(null);
    const charger = React.useCallback(() => {
        if (!eventId) return;
        moduleApi.getOrganisateurAcces(eventId).then((r: any) => setInfo(r && Array.isArray(r.acces) ? r : { acces: [], journal: [], contact: { name: '', email: '' }, max: 2 })).catch(() => setInfo(null));
    }, [eventId]);
    React.useEffect(() => { charger(); }, [charger]);
    const actifs = (info?.acces || []).filter((a) => a.etat === 'ok');
    return { info, actifs, recharger: charger };
}

/**
 * Carte de la maquette 18b, réservée au lot 9 et remplie ici (lot 10) : « L'organisateur peut faire ces
 * trois gestes à votre place ». Un seul bouton, « Gérer l'accès », qui ouvre la fenêtre 19d.
 */
export function OrganisateurAccesCard({ actifs, onGerer }: { actifs: AccesOrganisateur[]; onGerer: () => void }) {
    return (
        <div className="flex items-start gap-[13px] px-4 py-[15px] rounded-xl bg-surface border border-border flex-wrap sm:flex-nowrap">
            <span className="w-7 h-7 shrink-0 rounded-lg bg-surface-soft border border-border text-content flex items-center justify-center"><Link2 size={14} strokeWidth={1.9} /></span>
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap gap-y-1">
                    <span className="text-[13px] font-bold text-content">L'organisateur peut faire ces trois gestes à votre place</span>
                    {actifs.length > 0 && (
                        <span className="inline-flex items-center h-[22px] px-[9px] rounded-md bg-state-ok-soft border border-state-ok/30 text-state-ok text-[10px] font-bold tracking-[.06em] uppercase whitespace-nowrap">
                            Actif · {actifs.map((a) => a.name).join(', ')}
                        </span>
                    )}
                </div>
                <p className="mt-[3px] text-[12.5px] leading-[1.5] text-content-muted text-pretty">
                    Importer, envoyer, relancer : le client passe par un lien et un code provisoires, sur le même chemin que vous. Il ne voit ni tarif, ni contrainte alimentaire nominative.
                </p>
            </div>
            <button type="button" onClick={onGerer} className={pillSecondary(34)}>Gérer l'accès</button>
        </div>
    );
}
